// Author YuJiaBei
// Date 2020-11-10 15:12:04

class SithMesMstWorkshopLocation {
constructor({
        id = null,
        mstWorkshopId = '',
        mstWorkshopName = '',
        parentLocationName = '',
        mstLocationId = '',
        mstLocationName = '',
        remark = ''}
= {}) {
    this.id = id;
    this.mstWorkshopId = mstWorkshopId;
    this.mstWorkshopName = mstWorkshopName;
    this.parentLocationName = parentLocationName;
    this.mstLocationId = mstLocationId;
    this.mstLocationName = mstLocationName;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesMstWorkshopLocation();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'mstWorkshopId',
        label: 'label.sith.mst.sithMesMstWorkshopLocation.grid.mstWorkshopId',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'mstWorkshopName',
        label: 'label.sith.mst.sithMesMstWorkshopLocation.grid.mstWorkshopName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'mstLocationId',
        label: 'label.sith.mst.sithMesMstWorkshopLocation.grid.mstLocationId',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'parentLocationName',
        label: 'label.sith.mst.sithMesMstWorkshopLocation.grid.parentLocationName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'mstLocationName',
        label: 'label.sith.mst.sithMesMstWorkshopLocation.grid.mstLocationName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.mst.sithMesMstWorkshopLocation.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    mstWorkshopIdFilter : "",
    mstWorkshopNameFilter : "",
    mstLocationIdFilter : "",
    mstLocationNameFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'mstWorkshopNameFilter',
        label: 'label.sith.mst.sithMesMstWorkshopLocation.filter.mstWorkshopName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'sithMesMstWorkshop'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"mstWorkshopId":"id"}'
                }
        },
        {
        key: 'mstLocationNameFilter',
        label: 'label.sith.mst.sithMesMstWorkshopLocation.filter.mstLocationName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'sithMesMstLocation'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"mstLocationId":"id"}'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'mstWorkshopName',
        label: 'label.sith.mst.sithMesMstWorkshopLocation.entity.mstWorkshopName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'sithMesMstWorkshop'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"mstWorkshopId":"id"}'
                }
        },
        {
        key: 'parentLocationName',
        label: 'label.sith.mst.sithMesMstWorkshopLocation.entity.parentLocationName',
        sortable: true,
        disabled: true,
        form: {
        type: 'input'
                }
        },
        {
        key: 'mstLocationName',
        label: 'label.sith.mst.sithMesMstWorkshopLocation.entity.mstLocationName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'sithMesMstLocation'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"mstLocationId":"id"}'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.mst.sithMesMstWorkshopLocation.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {SithMesMstWorkshopLocation, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
